<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { Trash } from 'phosphor-svelte';
  import Button from '$lib/components/common/button/Button.svelte';

  export let title: string;
  export let isOpen = false;
  export let confirmTitle = "Yes, delete";

  const dispatch = createEventDispatcher();

  function handleConfirm() {
    dispatch('confirm');
  }

  function handleCancel() {
    dispatch('cancel');
    isOpen = false;
  }
</script>

{#if isOpen}
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <div
      class="fixed inset-0 bg-black bg-opacity-50"
      on:click={handleCancel}
      on:keydown={(e) => e.key === 'Escape' && handleCancel()}
      role="button"
      tabindex="0"
      aria-label="Close modal"
    ></div>

    <div class="relative rounded-lg bg-white shadow-xl" style="width: 500px;">
      <div class="p-6">
        <div class="mb-4 flex justify-center">
          <div class="rounded-full bg-error-100 p-3">
            <Trash size={24} class="text-error-500" />
          </div>
        </div>

        <h3 class="mb-2 text-lg font-semibold text-primary-500">{title}</h3>

        <div class="mb-6 text-sm text-gray-600">
          <slot />
        </div>

        <div class="flex justify-end gap-3">
          <Button label="Cancel" onClick={handleCancel} variant="outlined" colour="secondary" />
          <Button label="{confirmTitle}" onClick={handleConfirm} colour="error" />
        </div>
      </div>
    </div>
  </div>
{/if}
